import { Component, Input } from '@angular/core';

@Component({
    selector: 'a48-icon',
    templateUrl: './a48-icon.component.html',
    styleUrls: ['./a48-icon.component.scss']
})
export class A48IconComponent {
    @Input() item: { IsAct48: number, Act48SubInErr: boolean }
}
